import {Component, Input, OnInit} from '@angular/core';
import {AnswerOption} from '../../../data/models/test/answer';
import {MatRadioChange} from '@angular/material/radio';
import {AnswerService} from '../../../services/api/answer.service';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {Question} from '../../../data/models/test/question';

@Component({
  selector: 'app-answer-options-editor',
  templateUrl: './answer-options-editor.component.html',
  styleUrls: ['./answer-options-editor.component.css']
})
export class AnswerOptionsEditorComponent implements OnInit {

  @Input() readonly !: boolean;
  @Input() testId!: number;
  @Input() questionId!: number;
  @Input() options!: AnswerOption[];
  @Input() multiple = false;
  @Input() editMode!: boolean;
  @Input() question!: Question;
  @Input() testType!: string;

  constructor(
    private answerService: AnswerService,
  ) {
  }

  ngOnInit(): void {
  }

  updateOption(option: AnswerOption): void {
    this.options = (this.options || []).map(o => o.id === option.id ? option : o);
    this.syncQuestionOptions();
  }

  deleteOption(option: AnswerOption): void {
    this.options = (this.options || []).filter(o => o.id !== option.id);
    this.syncQuestionOptions();
  }

  onOptionCreate(option: AnswerOption): void {
    this.options = [...(this.options || []), option];
    this.syncQuestionOptions();
  }

  onOptionRadioChange(option: AnswerOption, event: MatRadioChange): void {
    if  (this.testType === "POLL") {
      return;
    }
    if (!this.readonly && option.id === +event.value && !this.editMode) {
      this.answerService.updateAnswerOption(this.testId, this.questionId, option.id, {
        isCorrect: true,
      })
        .then(o => {
          this.updateOption(o);
        });
    }
    if (this.editMode) {
        this.question.options.forEach(o => {
            if(o.id === option.id)  {
              o.isCorrect = true;
            } else {
              o.isCorrect = false;
            }
        });
        this.options = [...this.question.options];
    }
  }

  onOptionCheckChange(option: AnswerOption, event: MatCheckboxChange): void {
    if  (this.testType === "POLL") {
      return;
    }
    if (!this.readonly && option.isCorrect !== event.checked && !this.editMode) {
      this.answerService.updateAnswerOption(this.testId, this.questionId, option.id, {
        isCorrect: event.checked,
      })
        .then(o => {
          this.updateOption(o);
        });
    }
    if (this.editMode) {
      this.question.options.forEach(o => {
          if(o.id === option.id)  {
            o.isCorrect = event.checked;
          }
      });
      this.options = [...this.question.options];
  }
  }

  onOptionDelete(option: AnswerOption): void {
    if (this.readonly) {
      return;
    }
    this.deleteOption(option);
  }

  onOptionDrop(event: CdkDragDrop<AnswerOption[]>): void {
    if (this.readonly || event.previousIndex === event.currentIndex) {
      return;
    }
    this.answerService.updateAnswerOption(this.testId, this.questionId, event.item.data.id, {
      position: event.currentIndex + 1,
    }).then(option => {
      this.updateOption(option);
      moveItemInArray(this.options, event.previousIndex, event.currentIndex);
      this.syncQuestionOptions();
    });
  }

  onOptionUpdate(option: AnswerOption): void {
    this.updateOption(option);
  }

  private syncQuestionOptions(): void {
    if (this.question) {
      this.question.options = [...(this.options || [])];
    }
  }

}
